export const statusErrorDescription = {
  'forbidden': {
    title: 'Você não tem permissão para visualizar esta página.',
    description: '',
    errorDescription: '403 - Acesso Negado',
  },
  'internalError': {
    title: 'Erro ao carregar a lista.',
    description: 'Por favor, tente novamente mais tarde.',
    errorDescription: '500 - Erro Interno',
  },
  'generic': {
    title: 'Nosso sistema não se comportou como deveria',
    description: 'Por favor aguarde um momento e tente outra vez.',
    errorDescription: '',
  }
};
